import { useAuthContext } from '@providers/AuthProvider';

export const UserCard = () => {
  const { me } = useAuthContext();

  const welcome =
    new Date(me.createdAt).getTime() < Date.now() - 24 * 60 * 60 * 1000
      ? `Welcome back, ${me?.name}!`
      : `Welcome ${me?.name}!`;
  return (
    <div className="px-[15px]">
      <div className="font-medium text-sm leading-[130%] tracking-[0.02em] text-title">{welcome}</div>
    </div>
  );
};
